import type { CompetitionField, CompetitionRow, CompetitionUnavailableReason, CompetitionsList } from '@/api/competitions'

/*
 * When a competition's null is missing data rather than undefined, and why: the rule the
 * cells read per row, and the shared column-wide state (`../list/nullState`) reads across
 * rows.
 */

/**
 * The one rule for a null: why a row's null in `field` is missing data rather than
 * undefined, or none. Behaviour is missing only on a row whose website had not started
 * tracking (its `views` is null too); a null conversion rate beside counted views is
 * undefined (no viewing session).
 */
export function unavailableReason(
  row: CompetitionRow,
  field: CompetitionField,
  notAvailable: CompetitionsList['notAvailable'],
): CompetitionUnavailableReason | null {
  const reason = notAvailable[field]
  if (!reason) return null
  if (reason === 'before_first_event') return row.views === null ? reason : null
  return reason
}
